import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CelebrityInput } from "@pushup/types";
import { createCelebrity, deleteCelebrity, listCelebrities, updateCelebrity } from "./api";

const CELEBRITIES_KEY = ["celebrities"] as const;

export function useCelebrities() {
  return useQuery({
    queryKey: CELEBRITIES_KEY,
    queryFn: listCelebrities,
  });
}

export function useCreateCelebrity() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createCelebrity,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: CELEBRITIES_KEY });
    },
  });
}

export function useUpdateCelebrity() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: CelebrityInput }) =>
      updateCelebrity(id, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: CELEBRITIES_KEY });
    },
  });
}

export function useDeleteCelebrity() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteCelebrity,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: CELEBRITIES_KEY });
    },
  });
}
